import { PhotoEditorSDKUI, UIEvent } from 'photoeditorsdk'
import * as React from 'react'
import { Prompt } from 'react-router'
import { UprightStyle } from '../../types'
import { EDITOR_CONFIG } from './constants'

interface Props {
  onClose: () => void
  imageURL: string
  onExport: (img) => void
}

const style: UprightStyle = {
  editor: {
    height: '100vh',
    width: '100vw',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1000
  },
  exportDialog: { height: 90, width: 350 }
}

// This is copy pasted directly from the PESDK source
const ExportDialog = () => {
  return (
    <div
      style={style.exportDialog}
      className="pesdk-exporter-dialog-container"
      data-test="Dialog"
      role="dialog"
      aria-hidden="false"
    >
      <div data-test="DialogBody" className="pesdk-exporter-dialog-body">
        <div className="pesdk-exporter-dialog-body-container">
          <div className="pesdk-exporter-dialog-spinner-container">
            <div className="pesdk-spinner" />
            <div className="pesdk-spinner" />
            <div className="pesdk-spinner" />
            <div className="pesdk-spinner" />
          </div>
          <div className="pesdk-dialog-body-text">
            <h3 className="pesdk-exporting-text">Exporting...</h3>
            <div className="pesdk-exporting-wait-text">Just a few seconds...</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const PhotoEditor = ({ imageURL, onClose, onExport }: Props) => {
  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    let editor

    const keyupListener = e => {
      if (e.key === 'Esc' || e.key === 'Escape') {
        editor.close()
      }
    }

    const initEditor = async () => {
      // There is a bug in PESDK that will only boot the editor at the top of the screen
      window.scrollTo(0, 0)
      EDITOR_CONFIG.image = imageURL

      editor = await PhotoEditorSDKUI.init(EDITOR_CONFIG)

      editor.on(UIEvent.EXPORT, async imageSrc => {
        setLoading(true)
        await onExport(imageSrc)
        editor.close()
      })

      editor.on(UIEvent.CLOSE, () => {
        setLoading(false)
        onClose()
      })

      document.addEventListener('keyup', keyupListener, false)
      document.body.style.overflow = 'hidden'
    }

    initEditor()

    return () => {
      document.removeEventListener('keyup', keyupListener, false)
      document.body.style.overflow = null
    }

    // onExport would break this memoization and should be avoided in the dep array
    // Failure to do so would break the Photo Editor
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) //

  return (
    <div>
      {/* Prevent the back button from exiting the product form */}
      <Prompt when message='Are you sure you want to leave? Click "Close" to exit the editor.' />
      {loading && <ExportDialog />}
      <div id="editor" style={style.editor} />
    </div>
  )
}
